import { Anchor, type AnchorProps } from "#ui/link";

interface TelProps extends AnchorProps {
  children: React.ReactNode;
  href: string | undefined;
  hrefFn?: ((value: string) => string | undefined) | null;
}

export function Tel({ children, href, hrefFn, ...props }: TelProps) {
  return (
    <Anchor
      href={href && hrefFn ? hrefFn(href) : href}
      palette="unset"
      underline={false}
      {...props}
    >
      {children}
    </Anchor>
  );
}
